import { Box, Link, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import type Employee from 'modules/employees/store/models/Employee'

interface Props {
  employee: Employee
}

const HolidaysOverview = observer(({ employee }: Props) => {
  const { navigation } = useNavigation()
  const timeoffHref = navigation.employees.id.timeOff.fullPath({ id: employee.id })

  return (
    <Box flexDirection="column" justifyContent="center" alignItems="center" textAlign="center">
      <Text.Normal>{i18n.t('employees.termination.first_step.holidays_overview')}</Text.Normal>
      <Link.Href href={timeoffHref} target="_blank">
        {i18n.t('employees.termination.first_step.see_holidays')}
      </Link.Href>
    </Box>
  )
})

export default HolidaysOverview
